if (!customElements.get('custom-video-carousel')) {
  customElements.define(
    'custom-video-carousel',
    class CustomVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-carousel-scroller]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        if (!this.scroller) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
          this.nextButton.addEventListener('click', () => this.scrollByCard(1));
          this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          this.updateButtons();
        }

        this.setUpVideoObserver();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      scrollByCard(direction) {
        const card = this.scroller.querySelector('[data-carousel-card]');
        const gap = parseFloat(window.getComputedStyle(this.scroller).columnGap) || 12;
        const amount = card
          ? card.getBoundingClientRect().width + gap
          : this.scroller.clientWidth / 2;
        this.scroller.scrollBy({
          left: amount * direction,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      updateButtons() {
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
        this.prevButton.toggleAttribute('disabled', this.scroller.scrollLeft <= 0);
        this.nextButton.toggleAttribute('disabled', this.scroller.scrollLeft >= maxScroll);
      }

      setUpVideoObserver() {
        const videos = Array.from(this.querySelectorAll('video'));
        if (!videos.length) return;

        // Muted must be set via the property as well as the attribute,
        // otherwise iOS Safari can refuse programmatic playback.
        videos.forEach((video) => {
          video.muted = true;
        });

        if (this.reducedMotion.matches || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const playPromise = video.play();
                if (playPromise) playPromise.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.5, 1] }
        );

        videos.forEach((video) => this.observer.observe(video));
      }
    }
  );
}
